import styled from "styled-components";

export const Separator = styled.hr`
	border-top: 1px solid #eee;
`;